import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';

import { EnvBanner } from 'components/EnvBanner';
import { SiteBanner } from 'components/SiteBanner';
import { muiTheme } from 'config/muiTheme';
import { settings } from 'config/settings';
// eslint-disable-next-line import/order
import { BreadcrumbProvider } from 'contexts';
import AppPortal from 'pages/AppPortal/AppPortal';

import './index.css';

import reportWebVitals from './reportWebVitals';

const element = (
  <StyledEngineProvider injectFirst>
    <BrowserRouter basename={settings.PUBLIC_URL}>
      <QueryParamProvider adapter={ReactRouter5Adapter}>
        {
          //Display banner with name of ENV if not prod
          settings.ENVIRONMENT !== 'prod' && (
            <EnvBanner
              color={settings.ENVIRONMENT === 'stage' ? 'green' : 'purple'}
              text={settings.ENVIRONMENT?.toUpperCase() || 'DEV'}
            />
          )
        }
        <SiteBanner />
        <ThemeProvider theme={muiTheme}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <BreadcrumbProvider>
              <AppPortal />
            </BreadcrumbProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </QueryParamProvider>
    </BrowserRouter>
  </StyledEngineProvider>
);

ReactDOM.render(element, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
